import { styled } from '@mui/material/styles';

export const FixedSpinner = styled('div')({
  top: '25vh',
  left: '50vw',
  marginLeft: '-25px',
  position: 'fixed',
});

export const CenteredSpinner = styled('div')({
  height: '100px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
